import React from "react";
import {
	Card,
	CardActions,
	CardContent,
	CardHeader, Grid,
	IconButton, Tooltip,
	Typography,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import EditIcon from "@mui/icons-material/Edit";
import {useNavigate} from "react-router-dom";
import {createQueryParameterString} from "../../../../libraries/util/QueryParameterHelper";

interface IJobDefinitionProps {
	id: number;
	name: string;
	description: string;
	stepsCount: number;
	favourite: boolean;
	setFavourite: (id: number) => void;
}

export const JobDefinition: React.FC<IJobDefinitionProps> = (props) => {
	const navigate = useNavigate();
	
	return (
		<Grid item lg={4} md={6} sm={12}>
			<Card sx={{ maxWidth: 345, backgroundColor: "#f1f1f1" }}>
				<CardHeader
					title={props.name}
					subheader={Array(props.stepsCount).fill("O").join(" - ")}
				/>
				<CardContent>
					<Typography variant="body2" color="text.secondary">
						{props.description}
					</Typography>
				</CardContent>
				<CardActions disableSpacing>
					<Tooltip title={"View Jobs"}>
						<IconButton aria-label="View Jobs" onClick={() => navigate("/querytool/jobs?jobDefinitionId=" + props.id)}>
							<DensitySmallIcon />
						</IconButton>
					</Tooltip>
					<IconButton aria-label="Edit">
						<Tooltip title={"Edit"}>
							<EditIcon
								onClick={() => {
									navigate(`/querytool/jobdefinitions/modify${createQueryParameterString({jobDefinitionId: props.id})}`);
								}}
							/>
						</Tooltip>
					</IconButton>
					<IconButton aria-label="share" onClick={() => props.setFavourite(props.id)}>
						<Tooltip title={"Favourite"}>
							<FavoriteIcon color={props.favourite ? "error" : "inherit"} />
						</Tooltip>
					</IconButton>
				</CardActions>
			</Card>
		</Grid>
	);
};
